module.exports = __webpack_public_path__ + "static/media/event-booking-app.fa3c9069.png";